import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_URL } from '../config/api';

const CampaignContext = createContext();

export const useCampaign = () => {
  const context = useContext(CampaignContext);
  if (!context) {
    throw new Error('useCampaign debe usarse dentro de un CampaignProvider');
  }
  return context;
};

export const CampaignProvider = ({ children }) => {
  const [activeCampaign, setActiveCampaign] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar campañas al inicializar
  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/campaigns`, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setCampaigns(data);
        
        // Si hay campañas y no hay una activa, seleccionar la primera
        if (data.length > 0 && !activeCampaign) {
          setActiveCampaign(data[0]);
        }
      }
    } catch (error) {
      console.error('Error fetching campaigns:', error);
    } finally {
      setLoading(false);
    }
  };

  // Obtener secciones habilitadas para la campaña activa
  const getEnabledSections = () => {
    if (!activeCampaign || !activeCampaign.enabled_sections) {
      // Por defecto, todas las secciones están habilitadas
      return {
        analytics: true,
        campaigns: true,
        conversations: true,
        reports: true,
        osint: true
      };
    }

    try {
      return JSON.parse(activeCampaign.enabled_sections);
    } catch (error) {
      console.error('Error parsing enabled_sections:', error);
      return {
        analytics: true,
        campaigns: true,
        conversations: true,
        reports: true,
        osint: true
      };
    }
  };

  const value = {
    activeCampaign,
    setActiveCampaign,
    campaigns,
    setCampaigns,
    loading,
    fetchCampaigns,
    getEnabledSections
  };

  return (
    <CampaignContext.Provider value={value}>
      {children}
    </CampaignContext.Provider>
  );
};

export default CampaignContext;
